import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const NumberIcon: React.FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M12 4H10V10H4V12H10V20H4V22H10V28H12V22L20 22V28H22V22H28V20H22V12H28V10H22V4H20V10L12 10V4ZM20 20V12L12 12V20L20 20Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
